import { createContext,  useEffect, useState } from 'react';
import { Printer, PrintersResponse, PrinterResponse, CountriesResponse, Country } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type PrintersContextProps = {
    printers: Printer[];
    totalPage: number;
    loadPrinters: (page: number) => Promise<void>;
    addPrinter: ( printer: Printer ) => Promise<string>;
    updatePrinter: ( printer: Printer ) => Promise<string>;
    deletePrinter: ( id: number ) => Promise<string>;

}



export const PrintersContext = createContext({} as PrintersContextProps);

export const PrintersProvider = ({ children }: any) => {

    const [printers, setPrinters] = useState<Printer[]>([]);    
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    useEffect(() => {
        loadPrinters(0);
    }, [])


    const loadPrinters = async (pageActual) => {

        const resp = await topApi.get<PrintersResponse>('/printer/getPrinters');
        if(resp.status == 200){
            setPrinters([...resp.data.printers]);
            setTotalPage(1);
        }


    }

    const addPrinter = async (printer: Printer)  => {
        try {
            printer.id = undefined;
            const resp = await topApi.post<PrinterResponse>('/printer/', { printer });
            setPrinters([...printers, resp.data.printer]);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }
    

    const updatePrinter = async (printer:Printer) => {
        try {
            const resp = await topApi.put<Printer>(`/printer/${printer.id}`, { printer });
            
                setPrinters(printers.map(prod => {    
                    return (prod.id === printer.id)
                        ? resp.data["printer"]
                        : prod;
                }));
            
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
        
        
    }

    const deletePrinter = async (id: number) => {
        try {
            await topApi.delete<Printer>(`/printer/${id}`);
            setPrinters((prevPrinters) =>
                prevPrinters.filter((printer) => printer.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }       
    }

   

    return (
        <PrintersContext.Provider value= {{ printers, totalPage, loadPrinters, addPrinter, updatePrinter, deletePrinter}}>
            { children }
        </PrintersContext.Provider>
    );
}